import { KeyEvent, Keys } from "excalibur";
import { BaseFlow } from "../engine/baseFlow";
import { MyLevel } from "../level";

export type GameOverResult = {
  restart: boolean;
};

export class GameOverFlow extends BaseFlow<GameOverResult> {
  level: MyLevel;

  constructor(level: MyLevel) {
    super(level.engine.clock);
    this.level = level;
  }

  override async Execute() {
    console.log("Game over flow started");
    
    // Show the game over UI
    this.level.hudInterface.showGameOver = true;

    this.closeOnComplete(
      // Listen for ESC key to quit (no restart)
      this.level.engine.input.keyboard.on("release", (evt: KeyEvent) => {
        if (evt.key === Keys.Esc) {
          this.Complete({ restart: false });
        }
      }),

      // Listen for restart event from HUD
      this.level.hudInterface.events.on("restartgame", () => {
        this.Complete({ restart: true });
      }),
    );
  }

  override Complete(result: GameOverResult) {
    // Hide the game over UI
    this.level.hudInterface.showGameOver = false;
    super.Complete(result);
  }
}